import styled from "styled-components";
import { Row, Button } from "antd";

export const StyledFooterRow = styled(Row)`
  &&& {
    display: flex;
    justify-content: center;
    background-color: #000;
  }
`;

export const StyledFooterContent = styled(Row)`
  &&& {
    max-width: 1920px;
    display: flex;
    justify-content: space-evenly;
    background-color: #000;
    color: #fff;
  }
`;

export const StyledCopyrightRow = styled(Row)`
  &&& {
    background-color: black;
    color: white;
    font-family: "Open Sans";

    @media (min-width: 1600px) {
      font-size: 11px;
    }

    @media (min-width: 1200px) and (max-width: 1599px) {
      font-size: 10px;
    }

    @media (min-width: 992px) and (max-width: 1199px) {
      font-size: 10px;
    }

    @media (min-width: 768px) and (max-width: 991px) {
      font-size: 9px;
    }

    @media (min-width: 576px) and (max-width: 767px) {
      font-size: 9px;
    }

    @media (max-width: 575px) {
      font-size: 8px;
      text-align: center;
      padding: 15px 10px;
    }

    @media (min-width: 576px) {
      text-align: start;
      padding: 10px 0;
    }
  }
`;

export const StyledMenuButton = styled(Button)`
  &&& {
    display: block;
    color: white;
    font-family: "Open Sans";
    padding: 0;
    height: auto;
    margin-bottom: 8px;

    @media (max-width: 575px) {
      margin-left: auto;
      margin-right: auto;
    }

    &:hover {
      color: #1890ff;
      transform: translateX(4px);
      transition: all 0.3s ease;
    }
  }
`;

export const StyledSocialLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-family: "Open Sans";
  text-decoration: none;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  @media (max-width: 575px) {
    justify-content: center;
  }

  .anticon {
    font-size: 18px;
  }

  &:hover {
    color: #1890ff;
    transform: translateX(4px);
  }
`;

export const StyledFooterLink = styled.a`
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    color: #1890ff;
    text-decoration: underline;
  }
`;

export const StyledDescriptionText = styled.span`
  color: white;
  font-family: "Open Sans";
  text-align: start;

  @media (min-width: 1600px) {
    font-size: 16px;
  }

  @media (min-width: 1200px) and (max-width: 1599px) {
    font-size: 15px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    font-size: 14px;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    font-size: 13px;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    font-size: 12px;
  }

  @media (max-width: 575px) {
    font-size: 11px;
    text-align: center;
  }
`;
